<template>
  <router-view />
</template>

<script>
export default {
  name: 'QuestionsIndex'
}
</script>
